import moment from "moment"

import { useUI } from "providers/UIProvider"

import { IHolidayFormProps } from "./AddEditHolidayModalTypes"

import { Box, Flex } from "@chakra-ui/react"

import SelectTime from "components/UI/molecules/SelectTime"
import SelectDate from "components/UI/molecules/SelectDate"
import { setHours, setMinutes } from "date-fns"

const HolidayForm: React.FC<IHolidayFormProps> = ({
  values,
  errors,
  handleTimeChange,
  handleDateChange
}) => {
  const { T, lang } = useUI()

  return (
    <Box>
      <Flex justifyContent="space-between">
        <Box width="200px">
          <SelectTime
            name="startTime"
            label={T("holiday.form.start_time_label")}
            selected={values.startDate}
            onChange={handleTimeChange}
            minTime={setHours(setMinutes(new Date(), 0), 0)}
            maxTime={setHours(setMinutes(new Date(), 45), 23)}
          />
        </Box>
        <Box width="200px">
          <SelectTime
            name="endTime"
            label={T("holiday.form.end_time_label")}
            selected={values.endDate}
            minTime={values.startDate}
            maxTime={setHours(setMinutes(new Date(), 45), 23)}
            onChange={handleTimeChange}
          />
        </Box>
      </Flex>
      <Flex justifyContent="space-between" mt="25px">
        <Box width="200px">
          <SelectDate
            name="startDate"
            label={T("holiday.form.start_date_label")}
            selected={values.startDate}
            startDate={values.startDate}
            endDate={values.endDate}
            onChange={handleDateChange}
            minDate={moment().toDate()}
            locale={lang}
          />
        </Box>
        <Box width="200px">
          <SelectDate
            name="endDate"
            label={T("holiday.form.end_date_label")}
            selected={values.endDate}
            startDate={values.startDate}
            endDate={values.endDate}
            minDate={values.startDate}
            onChange={handleDateChange}
            locale={lang}
          />
        </Box>
      </Flex>
    </Box>
  )
}

export default HolidayForm
